// extracted by mini-css-extract-plugin
export default {"container":"sGqs","blockTitle":"CHGm","inputWrapper":"lhHh","field":"u1CP","chosenOption":"Ve8x","trigger":"fx67","options":"lH75","option":"OWl8","fieldError":"yeHV"};